import {
  ExamDateReadonlyField,
  type ExamDateReadonlyFieldProps,
  ExamTimeReadonlyFields,
  type ExamTimeReadonlyFieldsProps,
} from '@exam-center/exam-event-management';
import {
  CalendarTodayIcon,
  Flex,
  Grid,
  ReadonlyField,
  Text,
  WatchLaterOutlinedIcon,
} from '@shared/components';
import { dayjs } from '@shared/utils';

export type ExamScheduleReadonlyFieldProps = ExamDateReadonlyFieldProps &
  ExamTimeReadonlyFieldsProps & {
    examDate: {
      eventStartDate: Date;
      eventEndDate: Date;
    };
  };

export default function ExamScheduleReadonlyField(props: Readonly<ExamScheduleReadonlyFieldProps>) {
  const { examDate, sessions } = props;

  return (
    <Grid
      sx={(theme) => ({
        columnGap: theme.spacing(6),
        rowGap: theme.spacing(6),
        gridTemplateColumns: '240px 1fr',
      })}
    >
      <Text variant='body1Semibold'>วันที่สอบ</Text>
      <ExamDateReadonlyField examDate={examDate} />
      <Text variant='body1Semibold'>เวลาสอบทั้งหมด</Text>
      <ExamTimeReadonlyFields examDate={examDate} sessions={sessions} />
      <Text variant='body1Semibold'>วันที่เปิด-ปิดรับสมัคร</Text>
      <Grid
        sx={{
          columnGap: (theme) => theme.spacing(2),
          gridTemplateColumns:
            'minmax(min-content, 200px) minmax(min-content, 140px) max-content minmax(min-content, 200px) minmax(min-content, 140px)',
          alignItems: 'flex-end',
        }}
      >
        <ReadonlyField
          label='วันที่เปิดรับสมัคร'
          content={
            <Flex
              sx={{
                gap: (theme) => theme.spacing(1),
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Text>{dayjs(examDate?.eventStartDate).format('DD-MM-YYYY')}</Text>
              <CalendarTodayIcon
                sx={(theme) => ({
                  color: theme.palette.text.secondary,
                })}
              />
            </Flex>
          }
        />
        <ReadonlyField
          content={
            <Flex
              sx={{
                gap: (theme) => theme.spacing(1),
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Text>{dayjs(examDate?.eventStartDate).format('HH:mm')}</Text>
              <WatchLaterOutlinedIcon
                sx={(theme) => ({
                  color: theme.palette.text.secondary,
                })}
              />
            </Flex>
          }
        />
        <Text sx={{ p: (theme) => theme.spacing(8.5, 1, 2.5, 1) }}>ถึง</Text>
        <ReadonlyField
          label='วันที่ปิดรับสมัคร'
          content={
            <Flex
              sx={{
                gap: (theme) => theme.spacing(1),
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Text>{dayjs(examDate?.eventEndDate).format('DD-MM-YYYY')}</Text>
              <CalendarTodayIcon
                sx={(theme) => ({
                  color: theme.palette.text.secondary,
                })}
              />
            </Flex>
          }
        />
        <ReadonlyField
          content={
            <Flex
              sx={{
                gap: (theme) => theme.spacing(1),
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Text>{dayjs(examDate?.eventEndDate).format('HH:mm')}</Text>
              <WatchLaterOutlinedIcon
                sx={(theme) => ({
                  color: theme.palette.text.secondary,
                })}
              />
            </Flex>
          }
        />
      </Grid>
    </Grid>
  );
}
